import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber7Square: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="number-7-square, key"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.70117 16.25L13.375 9.125V9.03125H9.01562V7.79492H14.8984V9.05469L11.2832 16.25H9.70117Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNumber7Square;
